// Source of truth for the Personal Immunization Record (YellowCard) staff matrix.
// Each entry renders one rotated column header (VaccineNames) and one react-table
// column (getVaccinesColumns, id = name). A cell checkmarks when a patient's
// immunization record's lowercased value.name has an exact _.indexOf match in the
// entry's `immunizations` list (NOT substring/fuzzy) AND the record is given/overdue.
//
// `name` doubles as the react-table column id, so names must stay unique. Note the
// pre-existing display-label spellings ('Diphteria', 'Pertusis', 'Rabbies') are
// coordinated FE/BE labels — do not "fix" them, it would change column ids/headers.
//
// Extracted from view.jsx so the matrix data can be unit-tested without dragging in
// the React/Redux/Vite import graph. view.jsx re-exports DISEASES for existing
// consumers (e.g. Flow/flows.jsx).
export const DISEASES = [
  {
    name: 'Diphteria',
    immunizations: ['dtap-ipv-hib', 'dtdap-ipv', 'td', 'tdap', 'dtdap-opv', 'tdap-ipv'],
  },
  {
    name: 'Tetanus',
    immunizations: ['dtap-ipv-hib', 'dtdap-ipv', 'td', 'tdap', 'dtdap-opv', 'tdap-ipv'],
  },
  {
    name: 'Pertusis',
    immunizations: ['dtap-ipv-hib', 'tdap', 'dtdap-ipv', 'pediacel', 'tdap-ipv', 'pentacel'],
  },
  {
    name: 'Polio',
    immunizations: ['dtap-ipv-hib', 'dtdap-ipv', 'dtdap-opv', 'opv', 'ipv', 'tdap-ipv'],
  },
  {
    name: 'Haemophilus B (Hib)',
    immunizations: ['dtap-ipv-hib'],
  },
  {
    name: 'Rotavirus',
    immunizations: ['rot', 'rotavirus', 'rotarix', 'rotateq'],
  },
  {
    name: 'Pneumococcal',
    immunizations: ['ppv23', 'pvc13', 'pvc20', 'pneu-c15'],
  },
  {
    name: 'Respiratory Syncytial Virus',
    immunizations: ['rsv'],
  },
  {
    name: 'Measles',
    immunizations: ['mmr', 'mmrii', 'mmrv'],
  },
  {
    name: 'Mumps',
    immunizations: ['mmr', 'mmrii', 'mmrv'],
  },
  {
    name: 'Rubella',
    immunizations: ['mmr', 'mmrii', 'mmrv'],
  },
  {
    name: 'Varicella',
    immunizations: ['vzv', 'mmrii', 'mmrv'],
  },
  {
    name: 'Meningococcal-B',
    immunizations: ['4cmenb'],
  },
  {
    name: 'Meningococcal-C',
    immunizations: ['men-c'],
  },
  {
    name: 'Meningococcal-ACYW',
    immunizations: ['men-c-acyw'],
  },
  {
    name: 'HPV',
    immunizations: ['hpv4', 'hpv9'],
  },
  {
    name: 'Influenza',
    immunizations: ['inf'],
  },
  {
    name: 'Hepatitis-A',
    immunizations: ['hepa', 'hepa&b'],
  },
  {
    name: 'Hepatitis-B',
    immunizations: ['hepb', 'hepa&b'],
  },
  {
    name: 'Shingles',
    immunizations: ['rzv', 'zvl'],
  },
  {
    name: 'TB skin test',
    immunizations: ['tb skin test'],
  },
  {
    name: 'Rabbies',
    immunizations: ['rabavert', 'hyperrab'],
  },
];
